import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Co2Results, QuestionType } from '@/models/co2-quiz.model';
import { User, UserCo2QuizAnswer } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, onMounted, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserCo2Quiz',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  emits: ['reset'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore<ShiftCMSState & { us: UsersState }>();

const questions = computed<UserCo2QuizAnswer[]>(
  () => store.state.us.userCo2QuizAnswers,
);
const results = computed<Co2Results[]>(() => store.state.us.userCo2Results);

const headers = [
  { title: 'Questions', key: 'question.title' },
  { title: 'Answer', key: 'answer' },
  { title: 'Options', key: 'options' },
];

const resultHeaders = [
  { title: 'Date', key: 'resultsDate' },
  { title: 'Complete', key: 'isComplete' },
  { title: 'Valid', key: 'isValid' },
  { title: 'Options', key: 'options' },
];

const emit = __emit;

function resetCo2Quiz() {
  if (
    confirm(`Are you sure you want to reset this user's Co2 Quiz information`)
  ) {
    store.dispatch(UsersActions.ResetCo2Quiz, props.user);

    emit('reset');
  }
}

function deleteUserCo2Question(id: number) {
  store.dispatch(UsersActions.DeleteUserCo2Answer, {
    id,
    userId: props.user.id,
  });
}

function deleteUserCo2Results(id: number) {
  store.dispatch(UsersActions.DeleteUserCo2Results, {
    id,
    userId: props.user.id,
  });
}

onMounted(() => {
  store.dispatch(UsersActions.GetUserCo2Results, props.user.id);
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mt-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createTextVNode("Co2 Quiz ")),
          _createVNode(_component_v_btn, {
            color: "warning",
            onClick: resetCo2Quiz
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Reset")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: headers,
        items: questions.value,
        itemsPerPage: "10",
        hover: ""
      }, {
        "item.answer": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.question.questionType === _unref(QuestionType).UserInput ||
          item.answer?.isOther
            ? item.inputValue
            : item.answer?.text), 1)
        ]),
        "item.options": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            density: "compact",
            icon: "mdi-delete-outline",
            onClick: ($event: any) => (deleteUserCo2Question(item.id))
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Co2 Results")
        ])),
        _: 1
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        headers: resultHeaders,
        items: results.value,
        itemsPerPage: "10",
        hover: ""
      }, {
        "item.isComplete": _withCtx(({ item }) => [
          (item.isComplete)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                icon: "mdi-check-bold",
                color: "success"
              }))
            : _createCommentVNode("", true),
          (!item.isComplete)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                icon: "mdi-close-thick",
                color: "warning"
              }))
            : _createCommentVNode("", true)
        ]),
        "item.isValid": _withCtx(({ item }) => [
          (item.isValid)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                icon: "mdi-check-bold",
                color: "success"
              }))
            : _createCommentVNode("", true),
          (!item.isValid)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                icon: "mdi-close-thick",
                color: "warning"
              }))
            : _createCommentVNode("", true)
        ]),
        "item.options": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            density: "compact",
            icon: "mdi-delete-outline",
            onClick: ($event: any) => (deleteUserCo2Results(item.id))
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})